module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "order-price-section"
    }
  }, [_c('div', {
    staticClass: "container-new",
    staticStyle: {
      "text-align": "left",
      "overflow": "visible",
      "height": "195px"
    }
  }, [_c('div', {
    staticClass: "order-right-info"
  }, [_c('div', {
    staticClass: "order-price"
  }, [_c('h2', [_vm._v("Koszt dostawy:")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.deliveryCost) + " zł")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCostInput === true),
      expression: "showCostInput === true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manualDeliveryCost),
      expression: "manualDeliveryCost"
    }],
    staticStyle: {
      "border": "solid 1px #ddd",
      "padding": "4px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.manualDeliveryCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manualDeliveryCost = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cpointer",
    on: {
      "click": function($event) {
        return _vm.changeCost()
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryCostError),
      expression: "deliveryCostError"
    }],
    staticClass: "error-message"
  }, [_vm._v("Nie udało się przeliczyć kosztów dostawy. Skontaktuj się z działem Call Center pod adresem mailowym callcenter@dts.pl.")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "margin-top": "60px",
      "text-align": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showChangeCostInput()
      }
    }
  }, [_vm._v("Zmień koszt")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Koszt dostawy zawiera:")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" wniesienie"), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" rozpakowanie"), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" ustawienie"), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" drobny montaż"), _c('a', {
    attrs: {
      "href": "#",
      "data-tooltip": "Dokonanie drobnego montażu mebli w postaci : przykręcenia okuć mebla, przykręcenia boczków wersalek, narożników i foteli (z wyłączeniem finki oraz mebli w przypadku których jest potrzebna ingerencja w tapicerkę), montażu podnóżek, nóżek, stopek, listew ozdobnych do kanap i narożników, montaż kanap typu DL, montaż wezgłowia do łóżek typu RELAX, montaż zaczepów do narożników i łączenie elementów narożnika w całość. Drobny montaż nie obejmuje demontażu mebla w celu wniesienia do lokalu Klienta. Usługa drobnego montażu obejmuje powyższy zakres prac, przy założeniu, iż czas jej realizacji nie powinien zająć pracownikom więcej niż 15 minut na pojedynczy mebel."
    }
  }, [_vm._v(" [?]")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("✓")]), _vm._v(" wyrzucenie opakowań\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5205b2fb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderPrice.vue
// module id = 254
// module chunks = 1